<form *ngIf="profileForm" [formGroup]="profileForm" (ngSubmit)="onSubmit()">
  <app-card [title]="'My Profile'" [patientInfo]="{patientAccountId}">
    <h2>Patient Information</h2>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>First Name</mat-label>
        <input matInput formControlName="firstName" placeholder="First Name" readonly required>
        <mat-error *ngIf="profileForm.get('firstName')?.invalid">First name is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Last Name</mat-label>
        <input matInput formControlName="lastName" placeholder="Last Name" readonly required>
        <mat-error *ngIf="profileForm.get('lastName')?.invalid">Last name is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Date Of Birth</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="birthdate" placeholder="Date Of Birth"   required>
        <mat-datepicker-toggle matSuffix [for]="picker" ></mat-datepicker-toggle>
        <mat-datepicker #picker [disabled]="true"></mat-datepicker>
        <mat-error *ngIf="profileForm.get('birthdate')?.invalid">Date Of Birth is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Email Address</mat-label>
        <input matInput formControlName="email" placeholder="Email Address"  required>
        <mat-error *ngIf="profileForm.get('email')?.invalid">Email is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Primary Phone Type</mat-label>
        <mat-select formControlName="primaryPhoneTypeId" class="hidden-dropdown" readonly required>
          <mat-option *ngFor="let key of getPhoneTypeKeys()" [value]="key">
            {{ phoneTypes[key] }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="profileForm.get('primaryPhoneTypeId')?.invalid">Type is required </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Primary Phone Number</mat-label>
        <input matInput formControlName="primaryPhone" placeholder="Primary Phone Number" required>
        <mat-error *ngIf="profileForm.get('primaryPhone')?.invalid">Please enter a valid 10-digit Phone Number.</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field" [disabled]="isSubmitted">
        <mat-label>Alternate Phone Type</mat-label>
        <mat-select formControlName="alternatePhoneTypeId">
          <mat-option *ngFor="let key of getPhoneTypeKeys()" [value]="key">
            {{ phoneTypes[key] }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Alternate Phone Number</mat-label>
        <input matInput formControlName="alternatePhone" placeholder="Alternate Phone Number" >
      </mat-form-field>
    </div>


    <h2>Home Address</h2>
    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Address Line 1</mat-label>
        <input matInput formControlName="addressLine1" placeholder="Address Line 1" required>
        <mat-error *ngIf="profileForm.get('addressLine1')?.invalid">Address line 1 is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Address Line 2</mat-label>
        <input matInput formControlName="addressLine2" placeholder="Address Line 2">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>City</mat-label>
        <input matInput formControlName="city" placeholder="City" required>
        <mat-error *ngIf="profileForm.get('city')?.invalid">City is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>State</mat-label>
        <mat-select formControlName="state" required>
          <mat-option *ngFor="let state of states" [value]="state.stateProvCode">{{ state.stateProvName }}</mat-option>
        </mat-select>
        <mat-error *ngIf="profileForm.get('state')?.invalid">State is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-zipfield">
        <mat-label>Zip Code</mat-label>
        <input matInput formControlName="zipCode" placeholder="Zip Code" required>
        <mat-error *ngIf="profileForm.get('zipCode')?.invalid">Please enter a valid ZIP Code.</mat-error>
      </mat-form-field>
    </div>

    <div class="shipping-header">
      <h2>Shipping Address</h2>
      <mat-slide-toggle formControlName="sameAsHomeAddress" (change)="onToggleChange($event.checked)">
        Same as Home Address
      </mat-slide-toggle>

    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Address Line 1</mat-label>
        <input matInput formControlName="shippingAddressLine1" placeholder="Address Line 1" required>
        <mat-error *ngIf="profileForm.get('shippingAddressLine1')?.invalid">Shipping address line 1 is
          required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>Address Line 2</mat-label>
        <input matInput formControlName="shippingAddressLine2" placeholder="Address Line 2">
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-field">
        <mat-label>City</mat-label>
        <input matInput formControlName="shippingCity" placeholder="Shipping City" required>
        <mat-error *ngIf="profileForm.get('shippingCity')?.invalid">Shipping city is required</mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" class="form-field">
        <mat-label>State</mat-label>
        <mat-select formControlName="shippingState" required>
          <mat-option *ngFor="let state of states" [value]="state.stateProvCode">{{ state.stateProvName }}</mat-option>
        </mat-select>
        <mat-error *ngIf="profileForm.get('shippingState')?.invalid">Shipping state is required</mat-error>
      </mat-form-field>
    </div>

    <div class="form-row">
      <mat-form-field appearance="outline" class="form-zipfield">
        <mat-label>Zip Code</mat-label>
        <input matInput formControlName="shippingZipCode" placeholder="Shipping Zip Code" required>
        <mat-error *ngIf="profileForm.get('shippingZipCode')?.invalid">Please enter a valid ZIP Code.</mat-error>
      </mat-form-field>
    </div>

    <div class="profile-button-container">
      <p class="info-text">This information cannot be changed once you submit.</p>
      <div class="button-row">
        <button class="button-Secondary" [disabled]="profileForm.disabled" (click)="clear()">CLEAR</button>
        <button class="button-Primary" [disabled]="profileForm.disabled || !profileForm.valid" type="submit">SAVE</button>
      </div>
    </div>
    
    <!-- <div class="profile-image-section">
      <picture>
        <source srcset="assets/images/mobile/Profilemobile.png" media="(max-width: 767px)" />
        <source srcset="assets/images/tablet/Profiletab.png" media="(max-width: 1023px)" />
        <img src="assets/images/desktop/Profiledesk.png" alt="Profile Banner" class="profile-banner-image" />
      </picture>
    </div> -->
    <img src="assets/images/desktop/Profiledesk.png" alt="Enrollment Desk" class="enrollment-image" /> 

  </app-card>
</form>
<loading-spinner *ngIf="isLoading"></loading-spinner>